import useIsMobileView from "./use-is-mobile-view";

export default useIsMobileView;